module.exports = __webpack_public_path__ + "img/processing.c8209bf2.svg";